import { object } from "superstruct";

import GiftRegistryWithRegistrantSchema from "./GiftRegistryWithRegistrantSchema";

const DeleteGiftRegistryResponseSchema = object({
    deletedGiftRegistry: GiftRegistryWithRegistrantSchema,
});

export default DeleteGiftRegistryResponseSchema;
